import { archiveReviews, hotRanking, hotTags } from '@/mocks/home';

export default function ReviewArchive() {
  return (
    <section id="archive" className="scroll-mt-28 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_340px] lg:gap-10">
          <div>
            <div className="flex items-end justify-between border-b border-background-300 pb-5">
              <div>
                <span className="font-label text-xs tracking-[0.24em] text-primary-600">
                  ARCHIVE FEED / 往期回顾
                </span>
                <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
                  最新收录的旧料
                </h2>
              </div>
              <span className="hidden whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 font-label text-xs text-secondary-900 sm:block">
                共 1,280 期
              </span>
            </div>

            <p className="mt-4 font-body text-sm leading-7 text-foreground-600">
              每一条都保留了收录时的原始顺序与日期，标题在前、摘要在后，点开是完整的存档条目。
              下面这些是最近补录进馆的往期内容。
            </p>

            <ul className="mt-6 divide-y divide-background-200 border-t border-background-200">
              {archiveReviews.map((item) => (
                <li key={item.id}>
                  <a href="#archive" className="group flex cursor-pointer gap-4 py-5 md:gap-6">
                    <div className="hidden w-16 shrink-0 pt-1 sm:block">
                      <span className="font-heading text-xl font-black text-background-400 transition-colors group-hover:text-primary-500">
                        {item.seq}
                      </span>
                      <span className="mt-1 block font-label text-[11px] text-foreground-500">
                        {item.date}
                      </span>
                    </div>

                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="font-label text-[11px] text-foreground-500 sm:hidden">
                          {item.date}
                        </span>
                        {item.tags.map((tag) => (
                          <span
                            key={tag}
                            className="rounded-full bg-background-100 px-2.5 py-0.5 font-label text-[11px] text-foreground-600"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                      <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                        {item.title}
                      </h3>
                      <p className="mt-2 font-body text-sm leading-6 text-foreground-600">
                        {item.summary}
                      </p>
                      <div className="mt-3 flex flex-wrap items-center gap-x-5 gap-y-2 font-label text-xs text-foreground-500">
                        <span className="flex items-center gap-1.5">
                          <i className="ri-chat-3-line text-sm"></i>
                          {item.comments} 条热评
                        </span>
                        <span className="flex items-center gap-1.5">
                          <i className="ri-fire-line text-sm text-primary-500"></i>
                          热度 {item.hot}
                        </span>
                        <span className="hidden items-center gap-1.5 md:flex">
                          <i className="ri-calendar-line text-sm"></i>
                          {item.period}
                        </span>
                      </div>
                    </div>

                    <span className="hidden h-8 w-8 shrink-0 items-center justify-center self-center rounded-full border border-background-300 text-foreground-600 transition-colors group-hover:border-primary-400 group-hover:text-primary-600 md:flex">
                      <i className="ri-arrow-right-line text-base"></i>
                    </span>
                  </a>
                </li>
              ))}
            </ul>

            <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-lg border border-background-200 bg-background-100 px-5 py-4 sm:flex-row">
              <p className="font-body text-sm text-foreground-600">
                已经翻到第 8 条，更早的往期内容都在历史存档里。
              </p>
              <a
                href="#timeline"
                className="flex w-fit cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-foreground-800"
              >
                <i className="ri-history-line text-base"></i>
                去历史存档
              </a>
            </div>
          </div>

          <aside className="flex flex-col gap-6">
            <div id="hot" className="scroll-mt-28 rounded-lg border border-background-200 bg-background-50">
              <div className="flex items-center justify-between rounded-t-lg bg-primary-950 px-5 py-4">
                <h3 className="flex items-center gap-2 font-heading text-base font-bold text-background-50">
                  <i className="ri-fire-line text-accent-400"></i>
                  翻旧账热搜榜
                </h3>
                <span className="font-label text-[11px] text-background-300">每小时更新</span>
              </div>
              <ol className="divide-y divide-background-200 px-2">
                {hotRanking.map((row) => (
                  <li key={row.rank}>
                    <a href="#archive" className="group flex cursor-pointer items-center gap-3 px-3 py-3">
                      <span
                        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-label text-xs font-bold ${
                          row.rank <= 3
                            ? 'bg-accent-500 text-foreground-950'
                            : 'bg-background-200 text-foreground-700'
                        }`}
                      >
                        {row.rank}
                      </span>
                      <span className="min-w-0 flex-1 font-body text-sm leading-6 text-foreground-800 transition-colors group-hover:text-primary-700">
                        {row.title}
                      </span>
                      <span className="shrink-0 font-label text-[11px] text-foreground-500">
                        {row.heat}
                      </span>
                    </a>
                  </li>
                ))}
              </ol>
            </div>

            <div className="rounded-lg border border-background-200 bg-secondary-50 p-5">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-price-tag-3-line text-secondary-600"></i>
                旧料标签墙
              </h3>
              <p className="mt-2 font-body text-xs leading-6 text-foreground-600">
                翻旧账从关键词开始，靠标签定位往期存档。
              </p>
              <div className="mt-4 flex flex-wrap gap-2">
                {hotTags.map((tag) => (
                  <a
                    key={tag}
                    href="#archive"
                    className="cursor-pointer whitespace-nowrap rounded-full border border-secondary-200 bg-background-50 px-3 py-1.5 font-label text-xs text-secondary-900 transition-colors hover:border-secondary-500"
                  >
                    {tag}
                  </a>
                ))}
              </div>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <div className="flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className="ri-inbox-archive-line text-base"></i>
                </span>
                <div>
                  <p className="font-heading text-sm font-bold text-foreground-950">找不到想查的？</p>
                  <p className="font-label text-[11px] text-foreground-500">提交关键词，我们帮你补录</p>
                </div>
              </div>
              <div className="mt-4 flex items-center overflow-hidden rounded-md border border-background-300 bg-background-50">
                <input
                  type="text"
                  aria-label="提交要查的旧料关键词"
                  placeholder="输入人名 / 事件 / 年份"
                  className="h-9 flex-1 bg-transparent px-3 font-label text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none"
                />
                <button
                  type="button"
                  className="h-9 cursor-pointer whitespace-nowrap bg-secondary-500 px-3 font-label text-xs text-background-50 transition-colors hover:bg-secondary-600"
                >
                  提交
                </button>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}